import { slicedToArray as _slicedToArray, asyncToGenerator as _asyncToGenerator } from '../../_virtual/_rollupPluginBabelHelpers.js';
import _pt from '../../node_modules/prop-types/index.js';
import React, { useState, useRef, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getAuthComponentOptions } from './config.js';
import useLoggedIn$1 from './useLoggedIn.js';
import { HttpStatus } from '../../modules/api/constants.js';
import { ApiError } from '../../modules/api/errors.js';
import { refresh, reauthenticate } from '../../modules/auth/actions.js';

/**
 * High level wrapper component that forces a JWT refresh if not logged in
 * and will only render its children if logged in
 */

var AuthenticatedApp = function AuthenticatedApp(_ref) {
  var loadable = _ref.loadable,
      _ref$autoTokenRefresh = _ref.autoTokenRefresh,
      autoTokenRefresh = _ref$autoTokenRefresh === void 0 ? 30 * 1000 : _ref$autoTokenRefresh,
      onRefreshDeauthenticating = _ref.onRefreshDeauthenticating,
      _ref$invalidateTokens = _ref.invalidateTokens,
      invalidateTokens = _ref$invalidateTokens === void 0 ? false : _ref$invalidateTokens,
      children = _ref.children;
  var loggedIn = useLoggedIn$1();
  var dispatch = useDispatch();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasAttemptedReauthentication = _useState2[0],
      sethasAttemptedReauthentication = _useState2[1];

  var onRefreshDeauthenticatingRef = useRef(onRefreshDeauthenticating);
  onRefreshDeauthenticatingRef.current = onRefreshDeauthenticating;
  var defaultOnRefreshDeauthenticating = useCallback(function (reason) {
    if (reason && reason instanceof ApiError && reason.status === HttpStatus.ServiceUnavailable) {
      // cannot determine token validity, stay logged in until the service becomes available or an API request is triggered in the app
      return false;
    }
  }, []);
  useEffect(function () {
    var attemptReauthenticate = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (loggedIn) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return dispatch(reauthenticate(invalidateTokens));

              case 3:
                sethasAttemptedReauthentication(true);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function attemptReauthenticate() {
        return _ref2.apply(this, arguments);
      };
    }();

    attemptReauthenticate();
  }, []);
  useEffect(function () {
    if (!loggedIn || typeof autoTokenRefresh !== "number" || autoTokenRefresh <= 0) {
      return;
    }

    var timeout = setInterval(function () {
      var _onRefreshDeauthentic;

      dispatch(refresh(invalidateTokens, {
        onDeauthenticating: (_onRefreshDeauthentic = onRefreshDeauthenticatingRef.current) !== null && _onRefreshDeauthentic !== void 0 ? _onRefreshDeauthentic : defaultOnRefreshDeauthenticating
      }));
    }, autoTokenRefresh);
    return function () {
      return clearInterval(timeout);
    };
  }, [loggedIn, autoTokenRefresh, defaultOnRefreshDeauthenticating]);
  var LoadableComponent = loadable || getAuthComponentOptions().defaultLoadable;
  return hasAttemptedReauthentication ? /*#__PURE__*/React.createElement(React.Fragment, null, children) : /*#__PURE__*/React.createElement(LoadableComponent, {
    fluid: true,
    loading: true
  });
};

AuthenticatedApp.propTypes = {
  loadable: _pt.elementType,
  autoTokenRefresh: _pt.oneOfType([_pt.number, _pt.bool]),
  onRefreshDeauthenticating: _pt.func,
  invalidateTokens: _pt.bool,
  children: _pt.node
};
var AuthenticatedApp$1 = AuthenticatedApp;

export { AuthenticatedApp$1 as default };
